
(function(template){
    define('vue!app/views/vue/components/packageDivComponent/packageSelectionComponent/container',['Vue','helpers','vue!./serviceItem','vuex','vue!./mobileServiceSelector','underscore', 'jquery' ],function (Vue,helpers,serviceItem,vuex,mobileServiceSelector,_, $) {
        return {
            template: template,
            components: {
                'service-item': serviceItem,
                'mobile-service-selector':mobileServiceSelector
            },
            data: function(){
                return {
                    canFocusService: false
                }
            },
            computed: _.extend(vuex.mapState(['desktopMode','usersWithIds','users','selectedServices','loggedInUser','activeCategory','allCategories','activeService','services','packages','mobileCategoryShow', 'selectedCategoryFilter','guestProfiles', 'OTBactive']),{

                handleCategoryToggle:function(){
                return !this.desktopMode?this.mobileCategoryShow :true
                },
                filteredServices: function() {
                    var vm = this;
                    var catServiceMap = JSON.parse(JSON.stringify(this.services));
                   
                    if(app.customization.dynamicRestrictions && app.commonViewHelper.active_ttb_effects.hideSpaServiceCatByCatName){
                        var hideSpaServiceCatByCatNameResult = app.commonViewHelper.groupEffects(app.commonViewHelper.active_ttb_effects.hideSpaServiceCatByCatName);
                        if(hideSpaServiceCatByCatNameResult.isActive && hideSpaServiceCatByCatNameResult.value && hideSpaServiceCatByCatNameResult.value.length){
                            _.each(hideSpaServiceCatByCatNameResult.value, function(catName){
                                delete catServiceMap[catName];
                            });
                        }
                    }
                    // Dynamic restriction code for hideSpaServiceSubcatBySubcatName
                    if(app.customization.dynamicRestrictions && app.commonViewHelper.active_ttb_effects.hideSpaServiceSubcatBySubcatName){
                        var hideSpaServiceSubcatBySubcatNameResult = app.commonViewHelper.groupEffects(app.commonViewHelper.active_ttb_effects.hideSpaServiceSubcatBySubcatName);
                        if(hideSpaServiceSubcatBySubcatNameResult.isActive && hideSpaServiceSubcatBySubcatNameResult.value && hideSpaServiceSubcatBySubcatNameResult.value.length){
                            var allCatsNames = _.keys(catServiceMap);
                            _.each(allCatsNames, function(catName){
                                _.each(catServiceMap[catName], function(service){
                                    if(service.ItemSubcategory && hideSpaServiceSubcatBySubcatNameResult.value.indexOf(service.ItemSubcategory) > -1){
                                        // remove the service from the array
                                        catServiceMap[catName] = _.without(catServiceMap[catName], service);
                                    }
                                });
                            });
                        }
                    }

                    // Remove categories with no items
                    _.each(catServiceMap, function(cat, catName){
                        if(_.isEmpty(cat)){
                            delete catServiceMap[catName];
                        }
                    });

                    // Dynamic restriction code for hideSpaServicesByItemId
                    if(app.customization.dynamicRestrictions && app.commonViewHelper.active_ttb_effects.hideSpaServicesByItemId){
                        var hideSpaServicesByItemIdResult = app.commonViewHelper.groupEffects(app.commonViewHelper.active_ttb_effects.hideSpaServicesByItemId);
                        if(hideSpaServicesByItemIdResult.isActive && hideSpaServicesByItemIdResult.value && hideSpaServicesByItemIdResult.value.length){
                            _.each(catServiceMap, function(catServices, catName){
                                var filteredServices = _.filter(catServices, function(service){
                                    return _.indexOf(hideSpaServicesByItemIdResult.value, service.SpaItemId) == -1;
                                });
                                catServiceMap[catName] = filteredServices;
                            });
                        }
                    }
                    
                    if(this.selectedCategoryFilter == this.localStrings.stepper.body.pick.serviceTitle || this.OTBactive){
                        _.each(catServiceMap, function(servicesArr, categoryName){
                            catServiceMap[categoryName] = servicesArr.filter(function(service){ return service.type != "package" })
                        });
                    }else if(this.selectedCategoryFilter == this.localStrings.stepper.body.pick.packageTitle){
                        _.each(catServiceMap, function(servicesArr, categoryName){
                            catServiceMap[categoryName] = servicesArr.filter(function(service){ return service.type == "package" })
                        });
                    }

                    if(this.customization.allowDurationGrouper){
                    var sameServices = {};
                    var customDurationSeperator = this.localStrings.stepper.body.pick.service.multiDurationSeperator;
                    customDurationSeperator = helpers.escapeRegex(customDurationSeperator);
                    customDurationSeperator = customDurationSeperator.replace('duration', '\\d*');
                    var regex = new RegExp(customDurationSeperator, "g");

                    _.each(catServiceMap, function(servicesArr, categoryName){
                        var items = _.filter(servicesArr, function(el2){
                            return Array.isArray(el2.ItemName.match(regex));
                        })

                        if(items.length) {
                            var ungroup = [];

                            _.forEach(items, function(itm){
                                var replacedText = itm.ItemName.replace(regex, '');
                                var servItemName = replacedText.replace(/\s/g,'');
                                var servFullName = helpers.capitalize_Words(replacedText);

                                if(_.filter(items, function(itm2){return servItemName == itm2.ItemName.replace(regex, '').replace(/\s/g,'') }).length == 1){
                                    ungroup.push(itm.SpaItemId);
                                }
                            })

                        _.forEach(items, function(el3){

                               catServiceMap[el3.ItemCategory] = _.filter(catServiceMap[el3.ItemCategory], function(si){
                                   return el3.SpaItemId != si.SpaItemId || (ungroup.indexOf(si.SpaItemId) > -1);
                               })
                        })
                        }

                    })
                    }

                    _.each(catServiceMap, function(catItems, categoryName){
                        catServiceMap[categoryName] = app.commonViewHelper.sortHelper(_.sortBy(catItems, function(el){
                            return vm.customization.sortByPrice ? parseFloat(el.Price) : el.ItemName;
                        }))
                    })


                    return catServiceMap;
                },
                durationMatchingServices: function(){

                    if(!this.customization.allowDurationGrouper) return false;

                    var sameServices = {};

                    var customDurationSeperator = this.localStrings.stepper.body.pick.service.multiDurationSeperator;
                    customDurationSeperator = helpers.escapeRegex(customDurationSeperator);
                    customDurationSeperator = customDurationSeperator.replace('duration', '\\d*');
                    var regex = new RegExp(customDurationSeperator, "g");

                    var catServiceMap = JSON.parse(JSON.stringify(this.services));
                    if(this.selectedCategoryFilter == this.localStrings.stepper.body.pick.serviceTitle || this.selectedCategoryFilter == 'All'){
                        _.each(catServiceMap, function(servicesArr, categoryName){
                            catServiceMap[categoryName] = servicesArr.filter(function(service){ return service.type != "package" })
                        });

                        _.each(catServiceMap, function(servicesArr, categoryName){
                        var items = _.filter(servicesArr, function(el2){
                            return Array.isArray(el2.ItemName.match(regex));
                        })

                        if(items.length) {
                            var ungroup = [];

                            _.forEach(items, function(itm){
                                var replacedText = itm.ItemName.replace(regex, '');
                                var servItemName = replacedText.replace(/\s/g,'');
                                var servFullName = helpers.capitalize_Words(replacedText);

                                if(_.filter(items, function(itm2){return servItemName == itm2.ItemName.replace(regex, '').replace(/\s/g,'') }).length == 1){
                                    ungroup.push(itm.SpaItemId);
                                }
                            })

                        _.forEach(items, function(el3){
                            if(!(ungroup.indexOf(el3.SpaItemId) > -1)){
                                var replacedText = el3.ItemName.replace(regex, '');
                                var servItemName = replacedText.replace(/\s/g,'');
                                var servFullName = helpers.capitalize_Words(replacedText);
                                if(!sameServices[categoryName]) sameServices[categoryName] = {};
                                if(!Array.isArray(sameServices[categoryName][servItemName])) sameServices[categoryName][servItemName] = [];
                                el3['nameWoDuration'] = servFullName;
                                sameServices[categoryName][servItemName].push(el3);
                            }
                        })
                        }

                    })
                    return sameServices;
                    }

                },
                categoriesToShow: function(){
                    var vm = this;
                    if(this.customization.allowDurationGrouper && this.durationMatchingServices){
                        return _.uniq(_.keys(this.filteredServices).filter(function(key){ return vm.filteredServices[key].length>0 }).concat(_.keys(this.durationMatchingServices)));
                    }else{
                        return _.keys(this.filteredServices).filter(function(key){ return vm.filteredServices[key].length>0 });
                    }
                }
            }),
            methods: {
                handleKeyDown: function(e,index){
                    vm = this;
                    this.a11yKeyDown(e,
                    {
                        up: function() {
                            var indeToUse = index == 0 ? vm.categoriesToShow.length-1 : index-1;
                            $('#stepper-categories .componentItem')[indeToUse].focus();
                            $('#stepper-categories .componentItem')[indeToUse].click();
                            if(index == 0) {
                                e.preventDefault();
                                $('#stepper-categories .componentItem')[indeToUse].scrollIntoView({block:'center',behavior: "smooth"});
                            }
                        },
                        down: function() {
                            var indeToUse = index == vm.categoriesToShow.length-1 ? 0 : index+1;
                            $('#stepper-categories .componentItem')[indeToUse].focus();
                            $('#stepper-categories .componentItem')[indeToUse].click();
                            if(index == vm.categoriesToShow.length-1) {
                                e.preventDefault();
                                $('#stepper-categories .componentItem')[indeToUse].scrollIntoView({block:'center',behavior: "smooth"});
                            }
                        },
                        tab: function() {
                            e.preventDefault();
                            if($('#stepper-services .serviceItemComponent a.active').length > 0) {
                                $('#stepper-services .serviceItemComponent a.active').focus();
                            }else
                                $('#stepper-services .serviceItemComponent a')[0].focus();
                            // $('.content-spaPackageTpl #vue-cart .componentHeader .sidebar_switch .sidebar_slider')[0].scrollIntoView({block:'center',behavior: "smooth"});
                        },
                        shiftTab: function() {
                            e.preventDefault();
                            $('.content-spaPackageTpl .category-filter-container a').focus();
                            $('.content-spaPackageTpl .category-filter-container')[0].scrollIntoView({block:'center',behavior: "smooth"});
                        }
                    }
                    )
                },
                handleCategoryClick: function(category){
                    this.$store.commit('setActiveCategory',{category:category});
                    if(app.customization.googleAnalytics){
                        helpers.analyticsInit('setActiveCategory',[category, this.$store.state.services])
                    }
                    
                   // this.scrollToBottom() //only runs in mobilemode
                    if(this.localStrings.configuration['singleBookingMode']) this.$store.commit('removeServicesInSingleBookMode')
                    this.$store.commit('setmobileCategoryShow',!this.mobileCategoryShow)

                },
                scrollToBottom:function(){
                    vm = this
                    !vm.desktopMode? window.scrollTo({top: window.innerHeight ,left: 0,behavior: 'smooth'}):null
                },


            },
            watch: {
                selectedCategoryFilter: function(val){
                    var vm = this;
                    if(this.categoriesToShow.indexOf(vm.activeCategory) == -1) {
                        this.$store.commit('setActiveCategory',{category:this.categoriesToShow[0]});
                        if(app.customization.googleAnalytics){
                            helpers.analyticsInit('setActiveCategory',[this.categoriesToShow[0], this.$store.state.services])
                        }
                    }
                }
            },
            mounted: function () {
                var vm = this;
                var endLoop = false;
                var mutation = false;

                //As a part of age restriction, it is we need to call fetchCustomerProfile to fetch loggedIn user detail which has birthdate in it. Clear the schedulebtnValidation list to give it a fresh start
                this.$store.commit('setScheduleBtnValidity', {
                    action: "remove",
                    removeAll: true
                })

            },
            beforeMount:function(){
                var vm = this
                vm.$store.commit('setEditingFolioItemId','')
                       //As a part of age restriction, it is we need to call fetchCustomerProfile to fetch loggedIn user detail which has birthdate in it. Clear the schedulebtnValidation list to give it a fresh start
                helpers.fetchLoggedInCustomerProfile().then(function (profile) {

                    if (profile.Customer) {
                        var modifedProfile = _.extend({}, vm.guestProfiles[profile.Customer[0].CustomerId], profile.Customer[0])
                        vm.$store.commit('addGuestProfile', modifedProfile)

                        delete vm.guestProfiles[profile.Customer[0].CustomerId].requireDatePicker
                    }
                })
            }
        }
    });
})('<div> <div class="packageSelectionContainer" v-if="desktopMode"> <div id="stepper-categories"> <div v-if="OTBactive" class="app-body-header"><b>{{activeCategory}}</b></div> <div v-else class="app-body-header"><b>{{localStrings.stepper.body.pick.categoryHeader}}</b></div> <div id="stepper-categories-inner"> <div v-if="!OTBactive"> <div @keydown="handleKeyDown($event,index)" :class="[\'componentItem\',{\'active\' : category==activeCategory, \'focus-first\': index==0}]" :key="index" v-on:click="handleCategoryClick(category)" v-for="(category,index) in categoriesToShow" :tabindex="category==activeCategory ? 0 : -1"> {{ category }} </div> </div> <div v-else @keydown="handleKeyDown($event,index)" :key="index" v-on:click="handleCategoryClick(category)" v-for="(category,index) in categoriesToShow" :tabindex="category==activeCategory ? 0 : -1" :class="category==activeCategory ? \'disableCheck\' : null"> <input type="checkbox" :id="category" :name="category" :checked="category==activeCategory ? 1 : 0"> <label :for="category">{{ category }} </label> </div> </div> </div> <div id="stepper-services"> <div class="app-body-header"> <b>{{localStrings.stepper.body.pick.serviceHeader}}</b> <span class="bookingFor" v-show="OTBactive"> <b>{{this.localStrings.stepper.body.schedule.bookingForText}}</b> {{usersWithIds[Object.keys(users)[0]]}} </span> </div> <div class="accordion" id="accordion2" tabindex="-1"> <service-item :key="service.SpaItemId" :package_item="packages[service.SpaItemId]" v-for="(service,index) in filteredServices[activeCategory]" v-bind:service="service" :focusable="canFocusService" :index="index" :lastIndex="filteredServices[activeCategory].length-1" > </service-item> <service-item v-show="durationMatchingServices" :key="service[0].nameWoDuration + \'-\' + service[0].ItemCategory" :package_item="packages[service.SpaItemId]" v-for="(service,index) in durationMatchingServices[activeCategory]" v-bind:service="service" :focusable="canFocusService" :index="index" :lastIndex="durationMatchingServices[activeCategory].length-1" > </service-item> </div> </div> </div> <transition name="fade" mode="out-in" v-else> <mobile-service-selector v-bind:handleCategoryClick="handleCategoryClick" v-bind:categoriesToShow="categoriesToShow" :durationMatchingServices="durationMatchingServices" :filteredServices="filteredServices"> </mobile-service-selector> </transition> </div>');
